import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { reducers, AUTH_FEATURE_KEY } from './+state/auth.reducer';
import { AuthEffects } from './+state/auth.effects';

@NgModule({
    imports: [StoreModule.forFeature(AUTH_FEATURE_KEY, reducers), EffectsModule.forFeature([AuthEffects])],
})
export class LoginDataAccessLoginModule {}
